(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heroic-monsters-sponsors"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hm-sponsor-carousel')) {
    customElements.define('hm-sponsor-carousel', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.button = this.querySelector('.hm-team-sponsors__toggle');
        this.paused = this.dataset.autoplay !== 'true';
        this.update = () => {
          const running = !this.paused && !this.motion.matches;
          this.dataset.running = String(running);
          if (!this.button) return;
          this.button.hidden = this.motion.matches;
          const label = running ? this.dataset.pauseLabel : this.dataset.playLabel;
          this.button.setAttribute('aria-label', label);
          this.button.setAttribute('title', label);
        };
        this.button?.addEventListener('click', () => {
          this.paused = !this.paused;
          this.update();
        }, { signal: this.events.signal });
        this.motion.addEventListener('change', this.update, { signal: this.events.signal });
        this.update();
      }

      disconnectedCallback() {
        this.events.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heroic-monsters-sponsorship"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hm-scroll-logo')) {
    customElements.define('hm-scroll-logo', class extends HTMLElement {
      connectedCallback() {
        this.hero = this.closest('.heroic-monsters-sponsor__hero');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.events = new AbortController();
        this.schedule = () => {
          if (this.frame) return;
          this.frame = window.requestAnimationFrame(() => {
            this.frame = null;
            const bounds = this.hero.getBoundingClientRect();
            const distance = Math.max(0, -bounds.top);
            const progress = this.motion.matches ? 0 : Math.min(1, distance / Math.max(1, bounds.height * 0.6));
            this.style.setProperty('--hm-logo-opacity', String(1 - progress));
            this.style.setProperty('--hm-logo-offset', progress * 64 + 'px');
            this.style.setProperty('--hm-logo-scale', String(1 - progress * 0.1));
          });
        };
        document.addEventListener('scroll', this.schedule, { capture: true, passive: true, signal: this.events.signal });
        window.addEventListener('resize', this.schedule, { signal: this.events.signal });
        this.motion.addEventListener('change', this.schedule, { signal: this.events.signal });
        this.observer = new ResizeObserver(this.schedule);
        this.observer.observe(this.hero);
        this.schedule();
      }

      disconnectedCallback() {
        this.events.abort();
        this.observer.disconnect();
        window.cancelAnimationFrame(this.frame);
        this.frame = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muso-christmas-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('muso-launch-countdown')) {
    customElements.define('muso-launch-countdown', class extends HTMLElement {
      connectedCallback() {
        this.end = Date.parse(this.dataset.end);
        this.tick();
        if (Date.now() < this.end) this.interval = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.interval); }
      tick() {
        const remaining = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
        const clock = this.querySelector('[role="timer"]');
        if (!Number.isFinite(remaining) || remaining === 0) {
          clock.hidden = true;
          this.querySelector('.muso-countdown__expired').hidden = false;
          this.querySelector('.muso-countdown__headline').hidden = true;
          clearInterval(this.interval);
          return;
        }
        const units = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        for (const [unit, value] of Object.entries(units)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
        clock.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muso-reviews"] && !Shopify.designMode) return;
  try {
    
  const hydrateMusoReviewImages = () => {
    document.querySelectorAll('.muso-reviews .jdgm-carousel-item__product-image').forEach((image) => {
      if (image.getAttribute('src')) return;
      const source = image.dataset.srcRetina || image.dataset.src;
      if (!source) return;
      image.setAttribute('loading', 'eager');
      image.setAttribute('decoding', 'async');
      image.setAttribute('src', source);
    });
  };

  hydrateMusoReviewImages();
  document.addEventListener('DOMContentLoaded', hydrateMusoReviewImages);
  window.addEventListener('load', hydrateMusoReviewImages);
  window.setTimeout(hydrateMusoReviewImages, 800);
  window.setTimeout(hydrateMusoReviewImages, 1800);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["muso-shop-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-muso-shop-previous], [data-muso-shop-next]');

    if (!control) {
      return;
    }

    const card = control.closest('[data-muso-shop-card]');
    const slides = [...card.querySelectorAll('[data-muso-shop-slide]')];

    if (slides.length < 2) {
      return;
    }

    const currentIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
    const direction = control.matches('[data-muso-shop-previous]') ? -1 : 1;
    const nextIndex = (currentIndex + direction + slides.length) % slides.length;

    slides[currentIndex]?.classList.remove('is-active');
    slides[nextIndex].classList.add('is-active');
  });

  } catch(e) { console.error(e); }
})();
})();
